import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

// Services
import { HeaderService } from 'src/app/services/header/header.service';
import { LoginService } from 'src/app/services/login/login.service';
import { SharedService } from 'src/app/services/shared.service';
import { EditShoppingCarService } from 'src/app/services/header/edit-shopping-car/edit-shopping-car.service';
import { ListOrdersService } from 'src/app/services/header/list-orders/list-orders.service';
import { AmplitudeService } from 'src/app/services/amplitude.service';
import { InitAppService } from 'src/app/services/init-app/init-app.service';

// Models
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent implements OnInit {

  listSubcriptions: Subscription[] = [];

  showShoppingCar: boolean = false;

  hasSession: boolean = false;

  itemMenuSelected: number = 1;

  urlLogo: string = '';

  numberShoppingCar: number = 0;
  numberOrders: number = 0;

  menuMobile: boolean = false;
  menuDesktop: boolean = false;

  user: User = new User;

  constructor(
    private _headerService: HeaderService,
    private _sharedService: SharedService,
    private _rutaActiva: ActivatedRoute,
    private _amplitudeService: AmplitudeService,
    private _router: Router,
    private _loginService: LoginService,
    private _listOrdersService: ListOrdersService,
    private _initAppService: InitAppService
  ) { }

  ngOnInit(): void {
    this.checkSession();
    this.getUrlLogo();
    this.Listeners();
  }

  getUrlLogo(): void {
    if(localStorage.getItem('logo')) this.urlLogo = localStorage.getItem('logo');
  }

  Listeners(): void {
    this.listenerShowShoppingCar();
    this.listenerLoginSuccess();
    this.listenerChangeUrlLogo();
    this.listenerChangeUrlLogoInitApp();
    this.listenerUpdateNumberOrdersAndShoppingCar();
  }

  ngOnDestroy(): void {
    this.listSubcriptions.forEach((sub: Subscription) => { if (sub) sub.unsubscribe(); });
    this.itemMenuSelected = 1;
  }

  checkSession(): void {
    if(this._sharedService.validSession()){
      this.getDataOrderAndShoppingCar();
      this.hasSession = true;
    } else this.hasSession = false;
  }

  async getDataOrderAndShoppingCar(){
    let response: any = await this._headerService.getDataOrderAndShoppingCar( ).toPromise()
      .catch((err: HttpErrorResponse) => {
        console.log('Error al obtener la informacion de las ordenes');
        // if(err.status == 401 || err.status == 403) {
        //   alert('Su sesión a expirado.');
        //   this.closeSession()
        // } 
      });
    this.numberOrders = 0;
    this.numberShoppingCar = 0;
    if(response.data && response.data.pedidos && response.data.pedidos.number_shopping_car)
      this.numberShoppingCar = response.data.pedidos.number_shopping_car;
    if(response.data && response.data.pedidos && response.data.pedidos.number_orders)
      this.numberOrders = response.data.pedidos.number_orders;
    if(response.data && response.data.usuario )
      this.user = new User(response.data.usuario)
    
  }

  // async getCompanyLogo(){
  //   let response: any = await this._headerService.getCompanyLogo().toPromise()
  //     .catch((err: HttpErrorResponse) => {
  //       console.log('Error al obtener la informacion de las ordenes');
  //       if(err.status == 401 || err.status == 403) {
  //         alert('Su sesión a expirado.');
  //         this._sharedService.closeSession();
  //       }
  //     });
  //   if (response.data.empresa.categories) localStorage.setItem('client_categories', response.data.empresa.categories);
  //   else localStorage.removeItem('client_categories')
  //   if(response.data.empresa && response.data.empresa.logo){
  //     this.urlLogo = response.data.empresa.logo;
  //     localStorage.setItem('client_logo', response.data.empresa.logo);
  //     localStorage.setItem('client_cover', response.data.empresa.cover);
  //   }
  // }
  // }

  async getCompanyLogo(){
    let response: any = await this._headerService.getCompanyLogo().toPromise()
      .catch((err: HttpErrorResponse) => {
        console.log('Error al obtener la informacion de las ordenes');
        // if(err.status == 401 || err.status == 403) {
        //   alert('Su sesión a expirado.');
        //   this.closeSession()
        // }
      });
    if (response.data.empresa.categories) localStorage.setItem('client_categories', response.data.empresa.categories);
    else localStorage.removeItem('client_categories')
    if(response.data.empresa && response.data.empresa.logo){
      this.urlLogo = response.data.empresa.logo;
      localStorage.setItem('client_logo', response.data.empresa.logo);
      localStorage.setItem('client_cover', response.data.empresa.cover);
    }
  }

  openShoppingCar(): void {
    this.showShoppingCar = true;
    this._headerService.emmiterShowShoppingCar(true);
  }

  openLogin(): void {
    this._loginService.emmiterShowLogin(true);
  }

  openListOrders(): void {
    this._listOrdersService.emmiterOpenCardListOrders(true);
  }

  openMenuMobile() {
    this._headerService.emmiterShowMenuMobile(true);
  }

  openMenuDesktop() {
    this.menuDesktop = !this.menuDesktop;
  }

  goToHome(): void {
    if(localStorage.getItem('modality') && localStorage.getItem('modality') == 'salon'){
      let empresa = localStorage.getItem('clientId')
      let companyId = localStorage.getItem('companyId')
      let table_user = localStorage.getItem('table_user')
      this._router.navigate([`/menu/empresa/${empresa}/compania/${companyId}/modalidad/salon/mesa/${table_user}`])
    }else{
      this._router.navigate(['/'])
    }
  }

  closeSession(): void {
    this._sharedService.closeSession();
    location.reload()
  }

  listenerShowShoppingCar(): void {
    this.listSubcriptions.push(
      this._headerService.getSubjetItemMenuSelected().asObservable().subscribe(
        // data => this.itemMenuSelected = data
        data => data
      )
    );
  }

  listenerLoginSuccess(): void {
    this.listSubcriptions.push(
      this._loginService.getSubjetLoginSuccess().asObservable().subscribe(
        data => {
          this.hasSession = data
          this.checkSession()
        }
      )
    );
  }

  listenerChangeUrlLogo(): void {
    this.listSubcriptions.push(
      this._headerService.getSubjetUrlLogo().asObservable().subscribe(
        data => this.urlLogo = data
      )
    );
  }

  listenerChangeUrlLogoInitApp(): void {
    this.listSubcriptions.push(
      this._initAppService.getSubjetUpdateBrandLogo().asObservable().subscribe(
        data => this.urlLogo = data
      )
    );
  }
  
  listenerUpdateNumberOrdersAndShoppingCar(): void {
    this.listSubcriptions.push(
      this._headerService.getSubjetUpdateNumberOrdersAndShoppingCar().asObservable().subscribe(
        data => this.checkSession()
      )
    );
  }


}
